import { EventEmitter, Injectable, Output } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

type TablePages = 'scenes' | 'painter';

@Injectable()
export class ContainerService {

    zoom = new BehaviorSubject(null);
    resetMoveable = new BehaviorSubject(null);
    editorMode = new BehaviorSubject(null);
    swappingIds = new BehaviorSubject(null);
    scheduleEventSelectedIndex = new BehaviorSubject(null);
    scheduleSelectedEvent = new BehaviorSubject(null);
    activeSceneItemIds = new BehaviorSubject(null);
    toggleGuideline = new BehaviorSubject(null);
    isMouseOnScene = new BehaviorSubject(null);
    isMouseOnPlaylist = new BehaviorSubject(null);
    toolbarVisible = new BehaviorSubject<boolean>(true);
    downloadedSharedScenes = new BehaviorSubject(null);

    tableSelection = {
        scenes: {},
        painter: {}
    };
    stickerColor = '';
    blockSmallView = false;

    private $markedTableRow = new BehaviorSubject<any>(null);
    private playlistData = null;
    private categoryList = new BehaviorSubject(null);
    private crudScenePlayer = new BehaviorSubject(null);
    private $dndItem = new BehaviorSubject<any>(null);

    get playlist() {
        return this.playlistData;
    }

    set playlist(i_playlistData) {
        this.playlistData = i_playlistData;
    }

    constructor() {
    }

    updateZoom(ref) {
        this.zoom.next(ref);
    }

    updateResetMoveable(status) {
        this.resetMoveable.next(status);
    }

    updateEditorMode(mode: any) {
        this.editorMode.next(mode);
    }

    setToolbarVisible(visible: boolean) {
        this.toolbarVisible.next(visible);
    }

    getCategories() {
        return this.categoryList;
    }

    setCategories(categories: string[]) {
        this.categoryList.next(categories);
    }

    setScheduleEventSelectedIndex(data) {
        this.scheduleEventSelectedIndex.next(data);
    }

    setScheduleSelectedEvent(data) {
        this.scheduleSelectedEvent.next(data);
    }

    setTableSelection(page: TablePages, value) {
        if (!page || !value) return;

        Object.keys(value).forEach(key => {
            this.tableSelection[page][key] = value[key];
        });
    }

    getTableSelection(page: TablePages) {
        if (!page) return null;
        return this.tableSelection[page];
    }

    setMarkedTableRow(sceneId) {
        this.$markedTableRow.next(sceneId);
    }

    getMarkedTableRow() {
        return this.$markedTableRow;
    }

    listenCrudScenePlayer() {
        return this.crudScenePlayer;
    }

    setCrudScenePlayer(crudData) {
        this.crudScenePlayer.next(crudData);
    }

    getActiveSceneItemIds() {
        return this.activeSceneItemIds;
    }

    listenDndContent() {
        return this.$dndItem;
    }

    setDndContent(item, component = null, isDrop = false, isDragging = false, dropPointX = 0, dropPointY = 0) {
        if (item) {
            this.$dndItem.next({
                item,
                component,
                isDrop,
                isDragging,
                dropPointX,
                dropPointY
            });
        } else {
            this.$dndItem.next(null);
        }
    }
}
